<script>
  import { ignore, makeWebsiteRequest } from "../../Common/tools";
  import { onMount } from "svelte";
  import Table from "../../Table/Table.svelte";
  import ShowDomainRecords from "../../Popups/ShowDomainRecords.svelte";
  import ProvideEmail from "../../Popups/ProvideEmail.svelte";
  import {External, M} from "../../external";

  let selection = null;
  
  let tableData = {
    columns: [
      {
        key: "domain",
        label: M.DOMAIN,
        class: "flex-1 mw-220 ws-normal"
      },
      {
        key: "verificationStatusText",
        label: M.VERIFICATION,
        type: "text",
        rowClassConditions: [M.CONFIRM_EMAIL, M.PENDING, M.VERIFIED, M.FAILED],
        rowClasses: ["order-status pending", "order-status pending", "pay-status paid", "pay-status refunded"],
        class: "flex-1 mw-100 ws-normal"
      },
      {
        key: "dkimStatusText",
        label: M.AUTHORIZATION,
        type: "text",
        rowClassConditions: [M.CONFIRM_EMAIL, M.PENDING, M.VERIFIED, M.FAILED],
        rowClasses: ["order-status pending", "order-status pending", "pay-status paid", "pay-status refunded"],
        class: "flex-1 mw-100 ws-normal"
      },
      {
        type: "action",
        action: function (id, action, row) {
          if (action === "info") {
            showRecords(row.domain);
          } else if (action === "refresh") {
            External.Tools.makeWebsiteRequest({
              action: "refreshMarketingDomainStatus",
              data: {
                domain: row.domain
              },
              onOk: function () {
                loadDomains();
              }
            });
          } else if (action === "delete") {
            External.Tools.prompt(M.DELETE_DOMAIN, M.DELETE_DOMAIN_DESC, function () {
              External.Tools.makeWebsiteRequest({
                action: "deleteMarketingDomain",
                data: {
                  domain: row.domain
                },
                onOk: function (response) {
                  loadDomains();
                }
              });
            });
          } else if (action === "email") {
            sendEmailVerification(row.domain, false);
          }
        },
        items: (data) => {
          let deleteBtn = { text: M.DELETE_TITLE, icon: "fa-trash", tag: "delete" };
          if (data.dkimStatus === "VERIFIED" && data.verificationStatus === "VERIFIED") return [deleteBtn];
          if (data.dkimStatus === "NONE") return [{ text: M.RESEND_EMAIL, icon: "fa-refresh", tag: "email" }, deleteBtn];

          return [{ text: M.SHOW_VERIFICATION_RECORDS, icon: "fa-info", tag: "info" }, { text: M.REFRESH_STATUS, icon: "fa-refresh", tag: "refresh" }, deleteBtn];
        },
        class: "mw-40"
      }
    ],
    rows: []
  };

  const showRecords = async (domain) => {
    let response = await makeWebsiteRequest({
      action: "getMarketingDomainVerificationRecords",
      data: {
        domain: domain
      }
    });

    if (!response.data) {
      return;
    }

    let domainData = response.data;

    External.Tools.showWindow({
      isModal: false,
      withDarkBackground: true,
      showCloseButton: true,
      title: M.VERIFICATION_RECORDS,
      markup: '<div class="popup-widget-wrapper"></div>',
      width: 700,
      action: {
        onShow: function (popup, context) {
          popup.bindComponent(
            new ShowDomainRecords({
              target: context.find(".popup-widget-wrapper")[0],
              props: {
                data: domainData
              }
            })
          );
        }
      }
    });
  };

  let onClickRow = (row) => {};

  async function loadDomains(onDone) {
    onDone = onDone || ignore;

    let response = await makeWebsiteRequest({
      action: "getMarketingSettings"
    });

    if (!response.data) {
      return;
    }

    let domains = response.data.domains;
    
    domains.forEach((domain) => {
      switch (domain.verificationStatus) {
        case "NONE":
          domain.verificationStatusText = M.CONFIRM_EMAIL;
          break;
        case "PENDING":
          domain.verificationStatusText = M.PENDING;
          break;
        case "VERIFIED":
          domain.verificationStatusText = M.VERIFIED;
          break;
        case "FAILED":
          domain.verificationStatusText = M.FAILED;
          break;
      }
      switch (domain.dkimStatus) {
        case "NONE":
          domain.dkimStatusText = M.CONFIRM_EMAIL;
          break;
        case "PENDING":
          domain.dkimStatusText = M.PENDING;
          break;
        case "VERIFIED":
          domain.dkimStatusText = M.VERIFIED;
          break;
        case "FAILED":
          domain.dkimStatusText = M.FAILED;
          break;
      }
    });

    tableData = Object.assign({}, tableData, { rows: domains });
    onDone();
  }

  let showRecordsIfNotValid = (domain) => {
    for (let idx = 0; idx < tableData.rows.length; ++idx) {
      let row = tableData.rows[idx];
      if (row.domain === domain) {
        if (row.dkimStatus !== "VERIFIED" && row.verificationStatus !== "VERIFIED") {
          showRecords(domain);
        }
        return;
      }
    }
  };

  let createDomain = (token) => {
    External.Tools.makeWebsiteRequest({
      action: "addMarketingDomain",
      data: {
        token: token
      },
      onOk: function (response) {
        if (response.data && response.data.domain) {
          loadDomains(() => {
            showRecordsIfNotValid(response.data.domain);
          });
        } else {
          loadDomains();
        }
      },
      onNotOk: function () {
        loadDomains();
      }
    });
  };

  let sendEmailVerification = (domain, addNewDomain) => {
    External.Tools.showWindow({
      isModal: false,
      title: M.DOMAIN_OWNERSHIP,
      width: 400,
      action: {
        onShow: function (popup, ui) {
          popup.bindComponent(
            new ProvideEmail({
              target: popup.getContentArea(),
              props: {
                domain: domain
              }
            })
          );
        }
      },
      buttons: [
        External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, async function (popup) {
          let verificationEmail = popup.component().get();

          let answer = await makeWebsiteRequest({
            action: addNewDomain ? "addMarketingDomain" : "resendMarketingDomainVerificationEmail",
            data: {
              domain: domain.trim(),
              verificationEmail: verificationEmail.trim()
            }
          });
          if (answer) {
            External.Tools.showAutohideMessage(5000, verificationEmail.trim() + "@" + domain.trim() + " - " + M.VERIFICATION_EMAIL_SENT);
            popup.close();
            await loadDomains();
          }
        }),
        External.Button.MIDDLE_CANCEL
      ]
    });
  };

  let onCreateDomain = () => {
    External.Tools.promptForInput(M.VERIFY_NEW_DOMAIN, M.ENTER_DOMAIN_FOR_SENDING, async function (domain) {
      let response = await makeWebsiteRequest({
        action: "addMarketingDomain",
        data: {
          domain: domain.trim()
        }
      });

      if (response.data.shouldVerifyByEmail) {
        sendEmailVerification(domain, true);
      } else {
        await loadDomains(() => {
          showRecordsIfNotValid(domain);
        });
      }
    });
  };

  onMount(function () {
    let domainToken = External.WebPlatform.getUrlParameterMap(window.location.href)["t"];
    if (domainToken) {
      createDomain(domainToken);
    } else {
      loadDomains();
    }
  });
</script>

<div class="mt-25 col20 f-left mb-25">
  <div class="col20 flex-col f-left domain-table">
    <div class="col20 f-left">
      <div class="col20 f-left flex flex-col">
        <div class="flex-1">
          <h3 class="col20 f-left mb-5 t-center">{M.VERIFIED_DOMAINS}</h3>
          <span class="light-gray-text col20 f-left mb-15 t-center">{M.VERIFIED_DOMAINS_DESC}</span>
        </div>
        {#if tableData && tableData.rows && tableData.rows.length}
          <div class="col20 f-left t-center mb-25">
            <a class="middle-button with-icon blue inline-block f-none" on:click={onCreateDomain}>
              {M.ADD_DOMAIN}
            </a>
          </div>
        {/if}
      </div>
      <Table data={tableData.rows} activeColumns={tableData.columns} bind:selection onClick={onClickRow} hasSelection={false}>
        <div class="text-center col20 f-left" style="padding: 70px 30px; box-sizing: border-box;">
          <h4 class="col20 f-left t-center mb-15">{M.NO_VERIFIED_DOMAINS}</h4>
          <div class="col20 f-left t-center">
            <a class="middle-button blue with-icon inline-block f-none" on:click={onCreateDomain}>
              {M.ADD_DOMAIN}
            </a>
          </div>
        </div>
      </Table>
    </div>
  </div>
</div>
